import Reveal from "./Reveal";
import { useLang } from "../i18n/LanguageContext";

export default function HowItWorks() {
  const { t } = useLang();
  return (
    <section id="how" className="bg-espresso py-24 text-cream sm:py-32" data-testid="how-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <p className="text-[11px] uppercase tracking-[0.3em] text-ochre" data-testid="how-eyebrow">
            {t.how.eyebrow}
          </p>
          <h2 className="mt-6 max-w-2xl font-serif text-4xl font-light tracking-tight sm:text-5xl lg:text-6xl">
            {t.how.heading}
          </h2>
        </Reveal>

        <div className="mt-16 grid gap-12 md:grid-cols-3 md:gap-10">
          {t.how.steps.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.15}>
              <div className="border-t border-cream/15 pt-8" data-testid={`how-step-${i + 1}`}>
                <span className="font-serif text-5xl font-light italic text-ochre/80">{s.n}</span>
                <h3 className="mt-6 font-serif text-2xl font-light sm:text-3xl">{s.t}</h3>
                <p className="mt-4 max-w-xs text-base leading-relaxed text-cream/75">{s.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
